import $ from 'jquery';
import replaceSubmitButton from "./replaceSubmitButton";
const failedLogin = () => {
    if(window.location.search){
        console.log(window.location.search);
        if (window.location.search === '?login=failed'){
            const error = document.querySelector('.ume-login-modal-error');
            error.classList.toggle('d-none');
            replaceSubmitButton();
            $('#ume-login-modal').modal('show')
            const url = window.location.href;
            const newUrl = url.split('?')[0];

            history.replaceState({}, document.title, newUrl);

        }
    }
}
export default failedLogin;